import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '../actions/personal';
import * as api from '../api/personal';

export const {
  personalSubmitMessageWithEnter,
  personalSubmitMessageWithEnterSucceeded,
  personalSubmitMessageWithEnterFailed,
  personalBusylight,
  personalBusylightSucceeded,
  personalBusylightFailed,
  personalKeyboardShortcuts,
  personalKeyboardShortcutsSucceeded,
  personalKeyboardShortcutsFailed,
  personalLeftMenu,
  personalLeftMenuSucceeded,
  personalLeftMenuFailed,
  personalCustomCardMenu,
  personalCustomCardMenuSucceeded,
  personalCustomCardMenuFailed,
  personalSound,
  personalSoundSucceeded,
  personalSoundFailed,
  personalLastFromEmailIntegration,
  personalLastFromEmailIntegrationSucceeded,
  personalLastFromEmailIntegrationFailed,
  personalConversationCards,
  personalConversationCardsSucceeded,
  personalConversationCardsFailed,
  personalReplyAreaHeight,
  personalReplyAreaHeightSucceeded,
  personalReplyAreaHeightFailed,
  personalAddToFavouriteTeamMemberIds,
  personalAddToFavouriteTeamMemberIdsSucceeded,
  personalAddToFavouriteTeamMemberIdsFailed,
  personalRemoveFromFavouriteTeamMemberIds,
  personalRemoveFromFavouriteTeamMemberIdsSucceeded,
  personalRemoveFromFavouriteTeamMemberIdsFailed,
  personalToggleRememberMicrophoneAccess,
  personalToggleRememberMicrophoneAccessSucceeded,
  personalToggleRememberMicrophoneAccessFailed,
  personalToggleRememberElevioCardOpen,
  personalToggleRememberElevioCardOpenSucceeded,
  personalToggleRememberElevioCardOpenFailed,
  personalChangedElevioSelectedLanguage,
  personalChangedElevioSelectedLanguageSucceeded,
  personalChangedElevioSelectedLanguageFailed,
  personalToggleRememberKnowledgeCardOpen,
  personalToggleRememberKnowledgeCardOpenSucceeded,
  personalToggleRememberKnowledgeCardOpenFailed,
} = actions;

export const personal = [
  takeLatest(
    personalSubmitMessageWithEnter.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalSubmitMessageWithEnterSucceeded,
      personalSubmitMessageWithEnterFailed,
    ),
  ),
  takeLatest(
    personalLeftMenu.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalLeftMenuSucceeded,
      personalLeftMenuFailed,
    ),
  ),
  takeLatest(
    personalCustomCardMenu.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalCustomCardMenuSucceeded,
      personalCustomCardMenuFailed,
    ),
  ),
  takeLatest(
    personalSound.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalSoundSucceeded,
      personalSoundFailed,
    ),
  ),
  takeLatest(
    personalBusylight.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalBusylightSucceeded,
      personalBusylightFailed,
    ),
  ),
  takeLatest(
    personalKeyboardShortcuts.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalKeyboardShortcutsSucceeded,
      personalKeyboardShortcutsFailed,
    ),
  ),
  takeLatest(
    personalLastFromEmailIntegration.toString() as any,
    genWithPromise(
      api.updateSettings,
      personalLastFromEmailIntegrationSucceeded,
      personalLastFromEmailIntegrationFailed,
    ),
  ),
  takeLatest(
    personalConversationCards.toString() as any,
    genWithPromise(
      api.updateConversationCards,
      personalConversationCardsSucceeded,
      personalConversationCardsFailed,
    ),
  ),
  takeLatest(
    personalReplyAreaHeight.toString() as any,
    genWithPromise(
      api.updateReplyAreaHeight,
      personalReplyAreaHeightSucceeded,
      personalReplyAreaHeightFailed,
    ),
  ),
  takeLatest(
    personalAddToFavouriteTeamMemberIds.toString() as any,
    genWithPromise(
      api.addToFavouriteTeamMemberIds,
      personalAddToFavouriteTeamMemberIdsSucceeded,
      personalAddToFavouriteTeamMemberIdsFailed,
    ),
  ),
  takeLatest(
    personalRemoveFromFavouriteTeamMemberIds.toString() as any,
    genWithPromise(
      api.removeFromFavouriteTeamMemberIds,
      personalRemoveFromFavouriteTeamMemberIdsSucceeded,
      personalRemoveFromFavouriteTeamMemberIdsFailed,
    ),
  ),
  takeLatest(
    personalToggleRememberMicrophoneAccess.toString() as any,
    genWithPromise(
      api.toggleRememberMicrophoneAccess,
      personalToggleRememberMicrophoneAccessSucceeded,
      personalToggleRememberMicrophoneAccessFailed,
    ),
  ),
  takeLatest(
    personalToggleRememberElevioCardOpen.toString() as any,
    genWithPromise(
      api.toggleRememberElevioCardOpen,
      personalToggleRememberElevioCardOpenSucceeded,
      personalToggleRememberElevioCardOpenFailed,
    ),
  ),
  takeLatest(
    personalChangedElevioSelectedLanguage.toString() as any,
    genWithPromise(
      api.toggleElevioSelectedLanguage,
      personalChangedElevioSelectedLanguageSucceeded,
      personalChangedElevioSelectedLanguageFailed,
    ),
  ),
  takeLatest(
    personalToggleRememberKnowledgeCardOpen.toString() as any,
    genWithPromise(
      api.toggleRememberKnowledgeCardOpen,
      personalToggleRememberKnowledgeCardOpenSucceeded,
      personalToggleRememberKnowledgeCardOpenFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;
    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
